/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "cygovRestApi",
            "endpoint": "https://hglgjsc3d6.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "jiraWebhookApiV1",
            "endpoint": "https://3qozb2zh45.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xclnvb7tu5hydni3iwy5puzvwi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_cognito_identity_pool_id": "us-east-1:6d4a20f9-5f74-4285-98cc-b9589cc6824a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_kqYWxmXjz",
    "aws_user_pools_web_client_id": "6as027b7j5v6u908e974tb9b7s",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "cygov-source-code-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d25nv3l9qcbdpb.cloudfront.net",
    "aws_user_files_s3_bucket": "cygov-storage-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
